module.exports = __webpack_public_path__ + "static/media/googlePlay_badge.bf5fcce2.svg";